import React, { useState } from 'react';
import { Globe, Check } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../context/LanguageContext';

const languages = [
  { code: 'nl', label: 'Nederlands', flag: 'NL' },
  { code: 'en', label: 'English', flag: 'EN' },
  { code: 'de', label: 'Deutsch', flag: 'DE' },
  { code: 'fr', label: 'Fran\u00e7ais', flag: 'FR' },
];

const LanguageToggle = () => {
  const { lang, setLanguage } = useLanguage();
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      <Button
        data-testid="language-toggle"
        variant="ghost"
        size="sm"
        onClick={() => setOpen(!open)}
        className="rounded-full px-3 gap-1.5"
      >
        <Globe className="w-4 h-4" />
        <span className="text-xs font-bold uppercase">{lang}</span>
      </Button>

      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-10 z-50 bg-card border border-border rounded-xl shadow-xl py-1 min-w-[160px]" data-testid="language-dropdown">
            {languages.map((l) => (
              <button
                key={l.code}
                data-testid={`lang-${l.code}`}
                onClick={() => { setLanguage(l.code); setOpen(false); }}
                className="w-full flex items-center gap-3 px-4 py-2.5 text-sm hover:bg-muted transition-colors"
              >
                <span className="font-bold text-xs w-6">{l.flag}</span>
                <span className="flex-1 text-left text-foreground">{l.label}</span>
                {lang === l.code && <Check className="w-4 h-4 text-gold" />}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageToggle;
